import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { IVehiclePageData } from '../../../features/account/domain/pages/IVehiclePageData';
import { VehiclesPage } from '../../../features/account/vehicles/ui/VehiclesPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IVehiclePageData> =
	createGetStaticPropsWithPage(PassengersPageId.Vehicles);

export default VehiclesPage;
